import { render } from "./_form.vue?vue&type=template&id=6301c17e"
import script from "./_form.vue?vue&type=script&lang=js"
export * from "./_form.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/vvg/forum/resources/vue/topic/_form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6301c17e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6301c17e', __exports__)) {
    console.log('reload')
    api.reload('6301c17e', __exports__)
  }
  
  module.hot.accept("./_form.vue?vue&type=template&id=6301c17e", () => {
    console.log('re-render')
    api.rerender('6301c17e', render)
  })

}


export default __exports__